import { createClient } from '@supabase/supabase-js'

// Cargar desde el archivo `.env` (asegúrate que empieza por REACT_APP_)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
